import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import NewOrder from '../NewOrder';
import BncLogoSpinner from '../BncLogoSpinner';
import { fetchClientById } from '../../slices/clientSlice';

export default function ClientHubOrderComposer({ clientId, onClose }) {
	const dispatch = useDispatch();
	const [hydratingClient, setHydratingClient] = useState(true);

	useEffect(() => {
		let isActive = true;
		const timerId = window.setTimeout(async () => {
			if (!clientId) {
				if (isActive) {
					setHydratingClient(false);
				}
				return;
			}

			try {
				await dispatch(fetchClientById(clientId));
			} finally {
				if (isActive) {
					setHydratingClient(false);
				}
			}
		}, 0);

		return () => {
			isActive = false;
			window.clearTimeout(timerId);
			localStorage.removeItem('clientId');
		};
	}, [clientId, dispatch]);

	return (
		<div className="client-hub-order-composer">
			{hydratingClient && (
				<div className="client-hub-order-composer__loader">
					<BncLogoSpinner size={70} />
				</div>
			)}
			<NewOrder onClose={onClose} />
		</div>
	);
}
